import ReactDOM from 'react-dom/client';
import './index.scss';
import React from 'react';
import { AppRouter } from './AppRouter';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(<AppRouter></AppRouter>);
